import React, { useState ,useEffect} from "react";
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Button,
} from "@mui/material";
import axios from "axios";

const FilterControls = ({ onReportData, reportName, onLoadingChange }) => {
  const [practice, setPractice] = useState("All");
  const [market, setMarket] = useState("All");
  const [offOn, setOffOn] = useState("All");
  const [busUnit, setBusUnit] = useState("All");
  const [loading, setLoading] = useState(false);

  const handlePracticeChange = (event) => {
    setPractice(event.target.value);
  };

  const handleMarketChange = (event) => {
    setMarket(event.target.value);
  };

  const handleOffOnChange = (event) => {
    setOffOn(event.target.value);
  };

  useEffect(()=>{
    handleViewReport();
  },[])
  
   const handleViewReport = async () => {
    try {
      setLoading(true);
      if (onLoadingChange) onLoadingChange(true);

            const dashboardResponse = await axios.get(
          process.env.REACT_APP_API_BASE_URL+"/dashboard/report",
          {
            params: {
              practice,
              market,
              offOn,
            },
          }
        );
        if (onReportData) {
          onReportData(dashboardResponse.data, { practice, market, offOn }); // Pass filter values here
        }
      
    } catch (error) {
      console.error("Error fetching report:", error);
      // You might want to add error handling UI here
    } finally {
      setLoading(false);
      if (onLoadingChange) onLoadingChange(false);
    }
  };

  const isButtonDisabled =   loading;

  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      <FormControl size="small" sx={{ minWidth: 150 }}>
        <InputLabel id="practice-label">EIPO</InputLabel>
        <Select
          labelId="practice-label"
          id="practice-select"
          value={practice}
          label="EIPO"
          onChange={handlePracticeChange}
        >
          <MenuItem value="All">All</MenuItem>
          <MenuItem value="EPS PEGA">EPS PEGA</MenuItem>
          <MenuItem value="EPS IPM">EPS IPM</MenuItem>
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 150 }}>
        <InputLabel id="market-label">Geography</InputLabel>
        <Select
          labelId="market-label"
          id="market-select"
          value={market}
          label="Geography"
          onChange={handleMarketChange}
        >
          <MenuItem value="All">All</MenuItem>
          <MenuItem value="NA">NA</MenuItem>
          <MenuItem value="GGM">GGM</MenuItem>
          
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 150 }}>
        <InputLabel id="off-on-label">Offshore/Onsite</InputLabel>
        <Select
          labelId="off-on-label"
          id="off-on-select"
          value={offOn}
          label="Offshore/Onsite"
          onChange={handleOffOnChange}
        >
          <MenuItem value="All">All</MenuItem>
          <MenuItem value="onsite">onsite</MenuItem>
          <MenuItem value="offshore">offshore</MenuItem>
        </Select>
      </FormControl>

      
      <Button
        variant="contained"
        color="primary"
        onClick={handleViewReport}
        disabled={isButtonDisabled}
      >
        {loading ? "Loading..." : "View Report"}
      </Button>
    </Box>
  );
};

export default FilterControls;